var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAssistivNewSmall = function SvgAssistivNewSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 315 315"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#assistiv-new-small_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M157.297 314.593c86.872 0 157.296-70.424 157.296-157.296C314.593 70.424 244.169 0 157.297 0 70.424 0 0 70.424 0 157.297s70.424 157.296 157.297 157.296"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#assistiv-new-small_svg__b)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 163.004,
    cy: 174.518,
    r: 210.228,
    fill: "url(#assistiv-new-small_svg__c)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#assistiv-new-small_svg__d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 34.56,
    cy: -35.71,
    r: 128.441,
    fill: "#99CAFF"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    filter: "url(#assistiv-new-small_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.571 66.442c2.583-4.474 9.04-4.474 11.624 0l23.648 40.961c8.813 15.265-23.867 110.981-111.372 110.981-5.166 0-8.395-5.592-5.812-10.066z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.106 208.318c2.583 4.474-.645 10.067-5.811 10.067h-75.408c-2.479 0-4.344-2.265-3.788-4.681 6.449-27.997 20.998-52.891 41.043-72.075 1.807-1.729 4.734-1.259 5.984.906z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "assistiv-new-small_svg__b",
    width: 736.875,
    height: 736.874,
    x: -205.434,
    y: -193.919,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_31_217",
    stdDeviation: 79.105
  })), /*#__PURE__*/React.createElement("filter", {
    id: "assistiv-new-small_svg__d",
    width: 763.149,
    height: 763.15,
    x: -347.015,
    y: -417.285,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_31_217",
    stdDeviation: 126.567
  })), /*#__PURE__*/React.createElement("filter", {
    id: "assistiv-new-small_svg__e",
    width: 263.679,
    height: 241.712,
    x: 30.944,
    y: 25.281,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.401,
    dy: 5.401
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 21.603
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_31_217"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_31_217",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "assistiv-new-small_svg__c",
    x1: 151.196,
    x2: 267.83,
    y1: 174.518,
    y2: 427.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FF54"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "assistiv-new-small_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 314.593,
    height: 314.593,
    fill: "#fff",
    rx: 157.297
  })))));
};
export default SvgAssistivNewSmall;